// extracted by mini-css-extract-plugin
export default {"cls1":"renderResults-SecondaryResultText_cls1__midB8","cls2":"renderResults-SecondaryResultText_cls2__takvT renderResults-SecondaryResultText_cls1__midB8"};